import * as React from 'react';
import InfoIcon from '@atlaskit/icon/glyph/info';
import Tooltip from '@atlaskit/tooltip';

const HumanReadableIdentifierMissingIcon = () => {
  return (
    <span className="human-readable-identifier-missing-icon">
      <Tooltip tag="span" content="Human readable identifier missing">
        <InfoIcon primaryColor="#6554c0" label="no-readable-identifier" />
      </Tooltip>
    </span>
  );
};

export default HumanReadableIdentifierMissingIcon;
